module.exports = __webpack_public_path__ + "img/selected4-min.bb1410c4.png";